export const route = {
  home: '/',
  newHome: '/nueva-home',
  us: '/nosotros',
  physicalCommerce: '/comerciosfisicos',
  buyNowPayLater: '/buynowpaylater',
  help: '/ayuda',
  commerce: '/comercios',
  wt: '/prestamospersonales',
  blog: '/blog',
  jobs: '/empleos',
  investors: '/inversores',
  financeUserInformation: '/informacion-usuario-financiero',
  consumerProtection: '/defensaconsumidor',
  cancelCredit: '/cancelacion',
  unsubscribeInformation: '/informacion-darse-baja',
  branch: '/sucursal',
  whatsapp: '/whatsapp',
  uber: '/uber',
  recharge: '/carga-virtual',
  services: '/servicios',
  error: '/error',
  cellphoneRecharge: '/recarga',
  oldNotes: '/novedades/notas', // esta es la ruta de las notas de la web anterior
  news: '/novedades/*',
  payServices: '/pago-de-servicios',
  hubLoyal: '/fidelizados',
  hubCustomers: '/clientes',
  contracts: '/contrato-de-adhesion',
  motorcycle: '/creditos-para-motos',
  electro: '/creditos-para-electros',
  refurbish: '/creditos-para-refaccion',
  downloadApp: '/descargar-app',
};

export default route;
